import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ReAnalysisSessionsTable } from './ReAnalysisSessionsTable';
import { PatternComparisonTab } from './PatternComparisonTab';
import { BarChart, Activity, History, GitCompare } from 'lucide-react';

export const ReAnalysisManager: React.FC = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [selectedSessionData, setSelectedSessionData] = useState<{
    sessionId: string;
    fileId: string;
  } | null>(null);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  const handleSessionSelect = (sessionId: string, fileId: string) => {
    setSelectedSessionData({ sessionId, fileId });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Activity className="h-5 w-5" />
          Re-Analysis Management
        </CardTitle>
        <CardDescription>
          Monitor and manage re-analysis sessions with detailed tracking and comparison tools
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="sessions" className="space-y-4">
          <TabsList>
            <TabsTrigger value="sessions" className="flex items-center gap-2">
              <History className="h-4 w-4" />
              Sessions History
            </TabsTrigger>
            <TabsTrigger value="comparison" className="flex items-center gap-2">
              <GitCompare className="h-4 w-4" />
              Pattern Comparison
            </TabsTrigger>
            <TabsTrigger value="statistics" className="flex items-center gap-2">
              <BarChart className="h-4 w-4" />
              Statistics
            </TabsTrigger>
          </TabsList>

          <TabsContent value="sessions">
            <ReAnalysisSessionsTable 
              refreshTrigger={refreshTrigger} 
              onSessionSelect={handleSessionSelect}
            />
          </TabsContent>

          <TabsContent value="comparison">
            <PatternComparisonTab 
              sessionId={selectedSessionData?.sessionId}
              fileId={selectedSessionData?.fileId}
            />
          </TabsContent>

          <TabsContent value="statistics">
            <Card>
              <CardHeader>
                <CardTitle>Re-Analysis Statistics</CardTitle>
                <CardDescription>
                  Overall statistics and performance metrics
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="text-center py-8 text-muted-foreground">
                  Statistics dashboard will be available here
                </div>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};